import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { stringToSemanticDisplay } from '../../../../utils/DateUtils';
import { useStyles } from './style';

interface CAECertificateDetailsProps {
  type: string;
  centreReferenceNo: string;
  verificationNo: string;
  countryTaken: string;
  dateTaken: string;
}

const CAECertificateDetails = ({
  certificateDetails,
}: {
  certificateDetails: CAECertificateDetailsProps;
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { type, centreReferenceNo, verificationNo, countryTaken, dateTaken } = certificateDetails;

  return (
    <Box className={`${classes.container} ${classes.marginTop1}`}>
      <Typography variant="h3" className={classes.subheader}>
        {t('exam->>NonNationalExam.CAECertificateDetails')}
      </Typography>

      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue keyText={t('exam->>NonNationalExam.CEQType')} valueText={type} />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('exam->>NonNationalExam.CentreReferenceNo')}
            valueText={centreReferenceNo}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('exam->>NonNationalExam.VerificationNo')}
            valueText={verificationNo}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue keyText={t('exam->>NonNationalExam.CountryCEQ')} valueText={countryTaken} />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('exam->>NonNationalExam.DateOfCEQTaken')}
            valueText={stringToSemanticDisplay(dateTaken)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CAECertificateDetails;
